import api from '@/api'
import lodash from 'lodash'

export default {
  namespaced: true,
  state: {
    lines: [],
    date: new Date(),
    selectedLine: {},
    data: {
      date: '',
      lines: []
    },
    changed: false
  },
  mutations: {
    updateLineChecked (state, param) {
      const o = lodash.find(state.data.lines, {title: param.line.title})
      o.checked = param.checked
    },
    selectLine (state, line) {
      state.selectedLine = line
    },
    updateLineCount (state, param) {
      var o = lodash.find(state.selectedLine.counts, {time: param.origin.time})
      lodash.extend(o.values, param.values)
      state.changed = true
    },
    addLineStaffs (state, param) {
      const sfs = state.selectedLine.staffs
      param.staffs.filter(s => !lodash.find(sfs, {_id: s._id})).forEach(s => sfs.push(JSON.parse(JSON.stringify(s))))
      state.changed = true
    },
    removeLineStaffs (state, param) {
      const sfs = state.selectedLine.staffs
      lodash.remove(sfs, s => lodash.find(param.staffs, {_id: s._id}))
      state.changed = true
    },
    updateLineStaff (state, param) {
      var s = lodash.find(state.selectedLine.staffs, {_id: param.origin._id})
      lodash.extend(s, param.values)
      state.changed = true
    },
    restoreSelected (state) {
      if (state.selectedLine.title) {
        state.selectedLine = lodash.find(state.data.lines, {title: state.selectedLine.title})
      }
    }
  },
  actions: {
    initLines (context, lines) {
      context.state.lines = JSON.parse(JSON.stringify(lines))
    },
    async load (context, yyyymmdd) {
      console.log('productionStatus.load, ', yyyymmdd)
      const fillDefaultLines = (res) => {
        res.lines = context.state.lines.map((l) => {
          return {title: l, staffs: [], counts: [...Array(24).keys()].map((c) => { return {time: c + 6, values: {}} })}
        })
        return res
      }
      const createEmptyData = (yyyymmdd) => {
        const res = { date: yyyymmdd, tag: 'production_status', entity: 'production_status' }
        return fillDefaultLines(res)
      }
      const key = `production_status_${yyyymmdd}`
      var res = await api.getBIZ(`/api/content?uri=${key}`)
      if (!res || res.data.error) {
        await api.putBIZ(`/api/content`, {uri: key, content: createEmptyData(yyyymmdd)})
        res = await api.getBIZ(`/api/content?uri=${key}`)
      }
      res.data.lines.forEach(l => { l.checked = false })
      context.state.date = new Date([yyyymmdd.substring(0, 4), yyyymmdd.substring(4, 6), yyyymmdd.substring(6)].join('/'))
      context.state.data = res.data
      context.state.changed = false
      if (context.state.data.lines.length === 0) {
        fillDefaultLines(context.state.data)
        context.dispatch('update')
      }
      context.commit('restoreSelected')
    },
    async checkUpdate (context) {
      const yyyymmdd = context.state.data.date
      const key = `production_status_${yyyymmdd}`
      const res = await api.getBIZ(`/api/content?uri=${key}`)
      if (!res || !res.data || !res.data._rev || res.data._rev === context.state.data._rev) { return }
      context.state.data = res.data
      context.commit('restoreSelected')
    },
    async updateLineCountAndSave (context, param) {
      context.commit('updateLineCount', param)
      return context.dispatch('update')
    },
    async updateLineStaffsAndSave (context, param) {
      const mutations = {
        'add': 'addLineStaffs',
        'remove': 'removeLineStaffs',
        'update': 'updateLineStaff'
      }
      context.commit(mutations[param.type], param)
      return context.dispatch('update')
    },
    async update (context) {
      if (!context.state.changed) { return }
      const yyyymmdd = context.state.data.date
      const key = `production_status_${yyyymmdd}`
      await api.putBIZ(`/api/content`, {uri: key, content: context.state.data})
      await context.dispatch('load', yyyymmdd)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/productionStatus.js